import React from 'react';

const RadioList = (props) => {
  return (  
  <div className="form-group">
    <div className="col-sm-4">
        <label htmlFor={props.name} className="form-label">{props.title}</label>
        {props.badge ? <span className='badge'>必須</span> : ''}
    </div>
    <div className="col-sm-8">
    {Object.keys(props.options).map(item => {
      return (
    <label key={item} >
        <input
            className="radio-input"
            key={item}
            id={item}
            name={props.name}
            type={props.type}
            value={props.options[item]}
            onChange={props.handleChange}
            checked={props.value === props.options[item] ? true : false}
            style={{
                'width': 'auto'
            }}
        />
        <label
            className="radio-label"
            key={props.options[item]}
            style={{
                'margin': '0 10px 0 5px'
            }}
        >{props.options[item]}</label>
        </label>
      );
    })}
    </div>
  </div>
  )
}

export default RadioList;